import { useQuery } from '@tanstack/react-query';

import { categoryService } from '@/services/category.service';

export const useGetAllCategories = (pageNumber: number) => {
	const { data, isLoading, isError, error, refetch, isPending } = useQuery({
		queryKey: ['category', pageNumber],
		queryFn: () => categoryService.getAllCategories(pageNumber),
	});
	return {
		categories: data?.data ?? [],
		totalPages: data?.pageCount,
		isLoading,
		isError,
		error,
		refetch,
		isPending,
	};
};
